import {axiosInstance, getAuthToken}  from "../utils/Client";

export default class DailyActivityService {
    static getKpiData = (locationId, kpiList, startDate, endDate) => {
        let url = `/kpi_activity/count/${locationId}/?kpi_list=[${kpiList}]`;
        if(typeof startDate !== "undefined" && startDate !== "Invalid date") {
            url += `&start_date=${startDate}`;
        }

        if(typeof endDate !== "undefined" && endDate !== "Invalid date") {
            url += `&end_date=${endDate}`;
        }

        return axiosInstance.get(url,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getUserList = async (locationId) => {
        return await axiosInstance.get(`/users_except_agency_monitor/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getPDF = async (locationId, data) => {
        return await axiosInstance.post(`/kpi_activity/report/${locationId}/`, data,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getSelectedKpiList = async (locationId) => {
        return await axiosInstance.get(`/selected_kpi/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static putSelectedKpiList = async (locationId, selectedKpiObj) => {
        return await axiosInstance.put(`/selected_kpi/${locationId}/`, selectedKpiObj,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

}


// WEBPACK FOOTER //
// ./src/services/DailyActivityService.js